import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { InvoiceApiService } from 'src/app/services/api/invoice-api.service';
import { MessageService } from 'src/app/services/message.service';
import { validateFormGroup } from 'src/app/utils/form';

@Component({
  selector: 'app-open-bill-info-modal',
  templateUrl: './open-bill-info-modal.component.html',
  styleUrls: ['./open-bill-info-modal.component.scss'],
})
export class OpenBillInfoModalComponent implements OnInit {
  list: any[] = [];
  selectedList: any[] = [];
  type = 'personal';
  tab = 1;
  total = 0;
  pageSize = 5;
  currentPage = 1;
  formGroup: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: InvoiceApiService,
    private message: MessageService,
    private modalRef: MatDialogRef<OpenBillInfoModalComponent>,
    private router: Router,
  ) {
    this.formGroup = this.fb.group({
      title: ['', [Validators.required]],
      tax: [''],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    this.findUserEligibleOrders();
  }

  switchType(type: string) {
    this.type = type;
    const taxControl = this.formGroup.get('tax');
    if (type === 'personal') {
      taxControl?.clearValidators();
      taxControl?.setValue('');
    } else {
      taxControl?.setValidators([Validators.required]);
    }
    taxControl?.updateValueAndValidity();
  }

  submitInvoice() {
    if (!validateFormGroup(this.formGroup)) {
      return;
    }
    this.tab = 2;
  }

  loading = false;
  async submit() {
    try {
      this.loading = true;
      const value = this.formGroup.value;
      const order_ids = this.selectedList.map((item) => item.id);
      const r = await this.api.postInvoice(
        this.type,
        value.title,
        value.tax,
        value.email,
        order_ids,
      );

      if (r.status === 0) {
        this.tab = 3;
      } else {
        this.message.warn('提交失败');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  close() {
    this.modalRef.close();
    this.router.navigate(['/user/profile/orders']);
  }

  toggleSelect(item: any) {
    const index = this.selectedList.findIndex((s) => s.id === item.id);
    if (index > -1) {
      this.selectedList.splice(index, 1);
    } else {
      this.selectedList.push(item);
    }
  }

  isSelected(item: any): boolean {
    return this.selectedList.some((s) => s.id === item.id);
  }

  get allSelected(): boolean {
    return this.total > 0 && this.selectedList.length === this.total;
  }

  async toggleSelectAll() {
    if (this.allSelected) {
      this.selectedList = [];
      return;
    }
    try {
      const ids = new Set(this.selectedList.map((s) => s.id));
      const all: any[] = [...this.selectedList];
      for (let page = 1; page <= this.totalPages; page++) {
        const r = await this.api.findUserEligibleOrders(page, this.pageSize);
        const list = r.data?.list || [];
        for (const item of list) {
          if (!ids.has(item.id)) {
            ids.add(item.id);
            all.push(item);
          }
        }
      }
      this.selectedList = all;
    } catch (error) {}
  }

  get totalAmount(): number {
    return this.selectedList.reduce(
      (sum, item) => sum + (item.pay_price || 0),
      0,
    );
  }

  async findUserEligibleOrders() {
    try {
      this.loading = true;
      const r = await this.api.findUserEligibleOrders(
        this.currentPage,
        this.pageSize,
      );
      const data = r.data;
      this.list = data.list;
      this.currentPage = data.page;
      this.pageSize = data.page_size;
      this.total = data.total;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  get totalPages(): number {
    return Math.ceil(this.total / this.pageSize);
  }

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.goToPage(this.currentPage - 1);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.goToPage(this.currentPage + 1);
    }
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages || page === this.currentPage) {
      return;
    }
    this.currentPage = page;
    this.findUserEligibleOrders();
  }
}
